export default __webpack_public_path__ + "static/all-device-02c6efd7e638630d2a50aa7c416ada02.webp";